export default {
    tooltip: {
        trigger: 'axis',
    },
    grid: {
        left: 50,
        right: 40,
    },
    legend: {
        data: [],
        bottom: 0
    },
    xAxis: [
        {
            type: 'category',
            boundaryGap: true,
            data: []
        }
    ],
    yAxis: [
        {
            type: 'value',
            scale: true,
            boundaryGap: [0.2, 0.2],
            min: 0
        }
    ],
    series: [
        {
            name: '',
            type: 'bar',
            data: []
        },
        {
            name: '',
            type: 'line',
            data: [],
            showSymbol: false,
            itemStyle: {
                color: '#34669c'
            }
        },
        {
            name: '',
            type: 'line',
            data: [],
            showSymbol: false,
        }

    ]
};
